import type { Option } from '@usealloy/component-library';
import type { ActionType } from '~/dashboard/views/workflows/store/engine/constants';
import type { Action } from '~/dashboard/views/workflows/store/engine/types';

export interface AxisHeaderOptionMeta {
  name: string;
  actionType: ActionType;
  color: string;
}

export interface AxisHeaderActionOption extends Option {
  meta: AxisHeaderOptionMeta;
  children?: React.ReactNode;
}

export interface AxisHeaderAttributeOptionMeta {
  shortenedName: string;
  dataType: ActionDataType;
}

export interface AxisHeaderAttributeOption extends Option {
  meta: AxisHeaderAttributeOptionMeta;
}

export type Axis = 'X' | 'Y';

export interface AxisHeaderDropdownProps {
  axis: Axis;
  isDisabled?: boolean;
  // Optional action prop - if not provided, uses the focused action from Redux
  action?: Action;
}

export enum ActionDataType {
  'DECIMAL' = 'decimal',
  'INTEGER' = 'integer',
  'STRING' = 'string',
}
